export const challenge_newbie = require('./badges/challenge_newbie.png');
export const challenge_pro = require('./badges/challenge_pro.png');
export const deep_dive = require('./badges/deep_dive.png');
export const lab_builder = require('./badges/lab_builder.png');
export const service_all_star = require('./badges/service_all_star.png');
export const Home_bg = require('./home-header-back.png');
export const Aws = require('./aws.png');


// WEBPACK FOOTER //
// ./src/assets/img/index.js